import React, { useEffect, useRef, useState } from 'react'
import { Lock } from 'lucide-react'
import { formatDateTimeString } from '../../utils/commonUtils';
import { currencyToSymbol, convertSingleValueOnly } from '../../utils/commonUtils';


const DividendTable = ({ dividendData, dividendCurrency, selectedRows, setSelectedRows }) => {
    const scrollContainerRef = useRef(null);
    
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            // コンテナの最大スクロール幅を取得し、右端に設定
            scrollContainer.scrollLeft = scrollContainer.scrollWidth;
        }
    }, []); 
  
    const handleSelectRow = (column) => {
        if (selectedRows.includes(column)) {
            setSelectedRows(prevRows => prevRows.filter(row => row !== column));
        } else {
            setSelectedRows((prevRows) => [...prevRows, column])
        }
    }

    return (
        <div className="overflow-x-auto w-full" ref={scrollContainerRef}>
        <table className="w-full border-collapse border-none rounded-lg m-0 px-0">
            <thead>
            <tr>
                <th className="sticky left-0 z-10 w-[100px] min-w-[100pxpx] md:w-[200px] md:min-w-[200px]  text-left">項目</th>
                {dividendData.map((data, index) => (
                <th key={data.date} className="text-right bg-lightgrey min-w-[120px]">
                    {/* {formatDateTimeString(data.date, 'YYYY年m月')} */}
                    {data.fiscal_year + '年度'}
                </th>
                ))}
            </tr>
            </thead>
            <tbody>
                <tr
                className={
                    selectedRows.includes('dividend')
                      ? "bg-[#f3fff3]"
                      : "bg-white hover:bg-[rgb(245,245,245)]"
                  }
                  onClick={()=> handleSelectRow('dividend')}
                  >
                    <td className="sticky left-0 z-10 font-medium w-[100px] min-w-[100px] md:w-[200px] md:min-w-[200px] bg-gray-100 cursor-pointer p-3 border-b border-gray-300">
                        配当実績
                    </td>
                    {dividendData.map((data, index) => (
                        <td key={data.date} className={`text-right min-w-[120px] cursor-pointer p-3 border-b border-gray-300`}>
                        {index > dividendData.length - 6 ? (
                            convertSingleValueOnly(data['adjdividend'], 2) + currencyToSymbol(dividendCurrency)
                        ) : (
                            // <Lock className="inline-block w-4 h-4 text-gray-400" />
                            convertSingleValueOnly(data['adjdividend'], 2) + currencyToSymbol(dividendCurrency)
                        )}
                        </td>
                    ))}
                </tr>
                <tr
                className={
                    selectedRows.includes('payout_ratio')
                      ? "bg-[#f3fff3]"
                      : "bg-white hover:bg-[rgb(245,245,245)]"
                  }
                  onClick={()=> handleSelectRow('payout_ratio')}
                  >
                    <td className="sticky left-0 z-10 font-medium w-[100px] min-w-[100px] md:w-[200px] md:min-w-[200px] bg-gray-100 cursor-pointer p-3 border-b border-gray-300">
                        配当性向
                    </td>
                    {dividendData.map((data, index) => (
                        <td key={data.date} className={`text-right min-w-[120px] cursor-pointer p-3 border-b border-gray-300`}>
                        {index > dividendData.length - 6 ? (
                            convertSingleValueOnly(data['payout_ratio'], 2) + '%'
                        ) : (
                            // <Lock className="inline-block w-4 h-4 text-gray-400" />
                            convertSingleValueOnly(data['payout_ratio'], 2) + '%'
                        )}
                        </td>
                    ))}
                </tr>
                
            </tbody>
        </table>
        </div>
    )
}

export default DividendTable
